import { Button } from '@bfa/common-ui';
import styled from 'styled-components';

export const BoldedButton = styled(Button)`
  font-size: 1.8rem;
  font-family: NeueEinstellungBold;
  letter-spacing: 0.02rem;
  height: 5.2rem;
  width: 100%;
`;

export const GrayButton = styled(Button)`
  color: ${(props) => props.theme.colors.grayMedium};
  font-size: 1.4rem;
  margin-top: 0.3rem;
  margin-bottom: 0.8rem;
  &:hover {
    color: ${(props) => props.theme.colors.grayDarkest};
  }

  font-family: ${(props) => props.theme.fonts.bold};
  font-weight: bold;
`;
